export default ctx => {
  ctx.app.$rollbar?.configure({
    transform(payload) {
      payload.code_version = window.$versionTag
      payload.version = document.body.querySelector('#versionTag').innerText
      payload.currentCoach = ctx.store.state.coaching.current
      payload.currentQuiz = ctx.store.state.quiz.current
      payload.telemetry = {
        ...(ctx.store.state.telemetry.last || {}),
        fullSync: undefined,
      }
      const { user } = ctx.store.state.auth
      if (user) {
        // eslint-disable-next-line no-param-reassign
        payload.person = {
          id: user._id,
          name: user.name,
          username: user.name,
          employeeCode: user.employeeCode,
          jobTitle: user.jobTitle,
        }
      }
    },
  })
}
